import React from 'react';

const PaymentIssue = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-center p-6">
      <h1 className="text-2xl font-bold text-red-600 mb-4">Payment Provider Issue</h1>
      <p className="text-lg text-gray-800 mb-6">
        We are facing a payment provider issue right now. If you want to place an order,
        please contact us on Discord.
      </p>
      <a
        href="https://discord.com/invite/Kvmu2sPSpd"
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-600 hover:text-blue-800 font-semibold underline"
      >
        Join our Discord
      </a>
    </div>
  );
};

export default PaymentIssue;
